<template>
  <v-row
    align="center"
    justify="center"
    @click="close"
  >
    <v-overlay
      :absolute="true"
      z-index="9999"
    >
      <v-card>
        <v-img width="1024" :src="src" />
      </v-card>
    </v-overlay>
  </v-row>
</template>

<script>
import L from 'leaflet'
export default {
  props: {
    src: String
  },
  mounted () {
    L.DomEvent.disableClickPropagation(this.$el)
    L.DomEvent.disableScrollPropagation(this.$el)
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
